export const authExceptions = {
  onLogin: "El correo y/o contraseña son incorrectos.",
  onRegister: "No fue posible registrar el usuario.",
  onGetUserInfo: "No fue posible obtener la información del usuario.",
  onChangePassword: "No fue posible cambiar la contraseña.",
};
